import CreateWorkspaceView from './CreateWorkspaceView'

export default function () {
  return <CreateWorkspaceView />
}
